import { useLocation } from "react-router-dom";
import SubMenuButton from "../sub-menu-button";
import { cn } from "@/utils/cn";
import MenuAlert from "./menu-alert";
import React from "react";
import MenuButton from "./menu-button";

const menu = [
  {
    route: "/home",
    icon: "home",
    text: "Нүүр хуудас",
  },
  {
    route: "/alert",
    icon: "alerts",
    text: "Төлөв мэдээ",
  },
  {
    route: "/region",
    icon: "region",
    text: "Бүс нутаг",
    children: [
      { route: "/pheno/western", text: "Баруун бүс" },
      { route: "/pheno/central", text: "Төвийн бүс" },
      { route: "/pheno/eastern", text: "Зүүн бүс" },
      { route: "/pheno/gobi", text: "Говийн бүс" },
    ],
  },
  {
    route: "/pheno/cities",
    icon: "cities",
    text: "Хотууд",
    children: [
      { route: "/pheno/erdenet", text: "Эрдэнэт" },
      { route: "/pheno/darkhan", text: "Дархан" },
      { route: "/pheno/ulaanbaatar", text: "Улаанбаатар" },
    ],
  },
  {
    route: "/wind/all",
    icon: "sum",
    text: "Сумдууд",
    children: [
      { route: "/wind/western", text: "Баруун бүс" },
      { route: "/wind/central", text: "Төвийн бүс" },
      { route: "/wind/eastern", text: "Зүүн бүс" },
      { route: "/wind/gobi", text: "Говийн бүс" },
    ],
  },
  {
    route: "/forecast/ulaanbaatar",
    icon: "forecast",
    text: "Урьдчилсан мэдээ",
    children: [
      { route: "/forecast/ulaanbaatar", text: "Улаанбаатар" },
      { route: "/forecast/darkhan", text: "Дархан" },
      { route: "/forecast/erdenet", text: "Эрдэнэт" },
    ],
  },
];

const isExpanded = (route: string, pathname: string) => {
  if (route === pathname) return true;

  const groupMap: Record<string, string[]> = {
    "/region": [
      "/pheno/western",
      "/pheno/central",
      "/pheno/eastern",
      "/pheno/gobi",
    ],
    "/pheno/cities": ["/pheno/erdenet", "/pheno/darkhan", "/pheno/ulaanbaatar"],
    "/wind/all": ["/wind"],
    "/forecast/ulaanbaatar": ["/forecast"],
  };

  const matchRoutes = groupMap[route];
  return matchRoutes?.some((prefix) => pathname.startsWith(prefix));
};

const SkydataMainMenu: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <div className="flex items-center justify-around w-full  text-white  bg-blue-900 overflow-x-hidden ">
      {menu.map((item) => {
        const expanded = isExpanded(item.route, pathname);

        return (
          <React.Fragment key={`menu-${item.icon}`}>
            {item.route === "/alert" ? (
              <MenuAlert
                route={item.route}
                label={item.text}
                icon={item.icon}
              />
            ) : (
              <MenuButton route={item.route} icon={item.icon}>
                {item.text}
              </MenuButton>
            )}

            {item.children && expanded && (
              <div
                className={cn(
                  "absolute left-0 top-12 z-20 w-full",
                  expanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
                )}
              >
                <div className=" flex gap-2 w-full items-center justify-around">
                  {item.children.map((sub) => (
                    <SubMenuButton key={`sub-${sub.route}`} route={sub.route}>
                      {sub.text}
                    </SubMenuButton>
                  ))}
                </div>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default SkydataMainMenu;
